export const questionInputYesNoStyles = () => {
  return {
    width: "100%",
    ".true_question_yes_no_textbox_container": { marginLeft: "42px" },
  };
};
